<!--
 * @Author: M.D.
 * @Date: 2019-12-23 14:25:25
 * @LastEditors  : M.D.
 * @Description: 商品评价
 * @Remarks:
 -->
<template>
  <div class="evaluate-box">
    <el-row>
      <el-col :span="20" :offset="2">
        <el-container>
          <el-header height="50px">
            <span class="left-title">商品信息</span>
            <span class="right-title">评价</span>
          </el-header>
          <el-container style="background-color: white">
            <el-aside width="200px">
              <img :src="tImgUrl(orderInfo.image.split(',')[0])" alt="" :onerror="errImgDefault">
              <div>{{orderInfo.goodsName}}</div>
            </el-aside>
            <el-main>
              <div style="display: block; text-align:left; margin-bottom: 12px ">
                评分 <el-rate v-model="grade" show-text></el-rate>
              </div>
              <el-input
                maxlength="200"
                type="textarea"
                :rows="3"
                placeholder="请填写您的评价"
                v-model="textarea">
              </el-input>

              <div style="float:left;width: 80%">
                <el-upload
                  style="text-align: left;margin-top: 10px"
                  :action="uploadImgUrl"
                  list-type="picture-card"
                  :before-upload="chkImgNb"
                  :on-change="fileChange"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
              <div style="float:right;width: 10%">
                <el-button style="text-align: right;margin-top: 20px" @click="handleSubmit" :loading="loading" type="success">提交</el-button>
              </div>
            </el-main>
          </el-container>
        </el-container>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import API from '@/api/api'

export default {
  props: {},
  data () {
    return {
      orderInfo: {},
      textarea: '',
      fileList: [],
      loading: false,
      submitParam: {},
      grade: 4
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.initData()
  },
  mounted () {
  },
  activated () {

  },
  deactivated () {

  },
  watch: {},
  methods: {
    chkImgNb (file) {
      // 图片大小限制:2M
      if (file.size > 2 * 1024 * 1024) {
        this.$message({
          message: '上传文件大小不能超过2MB',
          type: 'error'
        })
        return false
      }

      // 图片上传个数限制:5个
      if (this.fileList && this.fileList.length <= 5) {
        return true
      } else {
        this.$message({
          message: '最多上传5张图片',
          type: 'error'
        })
        return false
      }
    },
    async initData () {
      const orRe = await API.getOrderDetail({ orderId: this.$route.query.orderId })
      this.orderInfo = orRe.data.result
    },
    handleRemove (file, fileList) {
      // console.log(file, fileList)
    },
    fileChange (file, fileList) {
      this.fileList = fileList
    },
    async handleSubmit () {
      if (!this.textarea) {
        this.$message({
          message: '请填写评价内容',
          type: 'warning'
        })
        return
      }
      if (!this.orderInfo.id) {
        this.$message({
          message: '无法提交',
          type: 'warning'
        })
        return
      }
      this.loading = true
      this.submitParam.comment = this.textarea
      this.submitParam.orderId = this.orderInfo.id
      this.submitParam.image = this.getImgStr()
      this.submitParam.grade = this.grade
      console.log(this.submitParam)
      try {
        const res = await API.saveComment(this.submitParam)
        if (res.data.statusCode === '200') {
          this.$message({
            type: 'success',
            message: res.data.message
          })
          this.$router.go(-1)
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      } catch (e) {
        this.$message({
          type: 'error',
          message: '请求错误，请检查网络'
        })
      } finally {
        this.loading = false
      }
    },
    getImgStr () {
      if (!this.fileList) {
        return ''
      }
      let array = []
      for (let item of this.fileList) {
        array.push(item.response.result)
      }
      return array.join(',')
      // let imgStr = ''
      // for (let item of this.fileList) {
      //   // console.log(JSON.stringify(item))
      //   if (imgStr) {
      //     imgStr = item.response.result
      //   } else {
      //     imgStr += `,${item.response.result}`
      //   }
      // }
      // return imgStr
    }
  }
}
</script>

<style lang="stylus">
  .evaluate-box
    margin-top 20px
    margin-bottom 40px

    .el-upload--picture-card
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 60px;
      height: 60px;
      cursor: pointer;
      line-height: 65px;
      vertical-align: top;

    .el-upload-list__item
      width: 60px;
      height: 60px;

  .el-header, .el-footer {
    background-color: #F5F5F5;
    color: #777777;
    text-align: center;
    line-height: 50px;

    .left-title {
      float left
      text-align center
      width 15%
    }

    .right-title {
      float right
      text-align center
      width 80%
    }
  }

  .el-aside {
    background-color: white;
    color: #333;
    text-align: center;
    max-height 200px
    padding-top 30px
    padding-left 30px
    padding-bottom 30px

    img {
      max-height 200px
      height 75%
      margin-bottom 8%
    }

    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left 10px
      padding-right 10px
    }
  }

  .el-main {
    background-color: white;
    color: #333;
    text-align: center;
    padding-left 30px
    padding-top 30px
  }

  body > .el-container {
    margin-bottom: 40px;
    border-style: solid;
    border-width: 2px;
    border-color #E5E5E5
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
</style>
